/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const FormGroup = ({
  children,
  className,
  orientation = 'vertical',
  gap = true
}) => {

  const isHorizontal = orientation === 'horizontal';
  const isVertical = orientation === 'vertical';
  const classes = classNames('sui-flex sui-flex-wrap', {
    'sui-flex-col': isVertical,
    'sui-flex-row': isHorizontal,
    'sui-gap-y-2': isVertical && gap,
    'sui-gap-x-6': isHorizontal && gap,
  }, className);

  return (
    <div className={classes} data-testid="form-group">
      {children}
    </div>
  );
};

FormGroup.displayName = 'FormGroup';

FormGroup.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  gap: PropTypes.bool
};

FormGroup.defaultProps = {};

export { FormGroup };